import React from "react";

const MetricDataComponent = ({metrics}) => metrics && <>
    <div className={'section-last-update'}>
        <div className="float-right">
            <span className={!metrics?.isActual && 'text-danger'}>última actualización: {metrics?.date}</span>
        </div>
    </div>
    <div className={'section-totales'}>
        <p><strong>#Idiomas:</strong>&nbsp; {metrics?.activeLangs}</p>
        <p><strong>#Modelos:</strong>&nbsp; {metrics?.totalModules || 0}</p>
        <p><strong>#Registros:</strong>&nbsp; {metrics?.totalRegisters || 0}</p>
        <p><strong>#Caracteres:</strong>&nbsp; {metrics?.totalCaracteres || 0}</p>
        <p><strong>Traducción al:</strong>&nbsp; {metrics?.percentageTranslatedRegisters || 0}%</p>
    </div>
</>

export default MetricDataComponent;